<div class="tree">
  <ul>
    <ng-container
      *ngTemplateOutlet="nodeTemplate; context: { $implicit: data }"
    ></ng-container>
  </ul>
</div>

<ng-template #nodeTemplate let-node>
  <li *ngIf="node">
    <div class="node-content" [class.node-disabled]="isNodeDisabled(node)">
      <div class="node-row">
        <input
          type="checkbox"
          class="node-checkbox"
          *ngIf="showCheckBox"
          [checked]="node.selected"
          [disabled]="isNodeDisabled(node)"
          (change)="onNodeCheckboxChange(node, $event)"
        />

        <div class="node-main-info">
          <img
            class="profile-pic"
            alt="User picture"
            [src]="pictureUrlMap[node.prid]"
            *ngIf="pictureUrlMap[node.prid]"
          />
          <p class="node-label">{{ node.label || "No Name" }}</p>
          <p *ngIf="node.title" class="node-title">{{ node.title }}</p>
          <p *ngIf="node.title" class="node-title">{{ node.email }}</p>
        </div>
      </div>

      <div *ngIf="node.subtitle" class="node-subtitle">{{ node.subtitle }}</div>

      <!-- Phase Indicator -->
      <div *ngIf="showPhaseIndicator && node.level" class="phase-indicator">
        <div
          class="phase-dot"
          [ngClass]="{ 'phase-active': isPhaseActive(node.level, 'Awareness') }"
        ></div>
        <div
          class="phase-dot"
          [ngClass]="{ 'phase-active': isPhaseActive(node.level, 'Interest') }"
        ></div>
        <div
          class="phase-dot"
          [ngClass]="{
            'phase-active': isPhaseActive(node.level, 'Experimentation')
          }"
        ></div>
        <div
          class="phase-dot"
          [ngClass]="{ 'phase-active': isPhaseActive(node.level, 'Adoption') }"
        ></div>
      </div>
    </div>
    <ul *ngIf="node.children && node.children.length > 0">
      <li *ngFor="let child of node.children">
        <ng-container
          *ngTemplateOutlet="nodeTemplate; context: { $implicit: child }"
        ></ng-container>
      </li>
    </ul>
  </li>
</ng-template>
